<template>
  <div
    v-loading="loading"
    class="home-page-container">
    <el-container class="home-container">
      <v-aside />
      <el-container class="in-container">
        <!--        <el-header>-->
        <!--          <v-header />-->
        <!--        </el-header>-->

        <!-- 暂时只是CS HOME需要白色背景 -->
        <el-main
          class="scroll-content"
          :class="{'white': $route.meta.bg_white}">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view
            v-if="!$route.meta.keepAlive"
            @loading="handleLoading" />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import VAside from '@/components/v-aside'
import {mapActions, mapState} from 'vuex'
import MixinAllOptions from '@/mixins/all-options'
// import { getAllOptions } from '@/api/common'
export default {
  name: 'HomeContainer',
  components: {
    // VHeader,
    VAside
  },
  mixins: [MixinAllOptions],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('common', ['allOptions', 'globalOptions','bankList'])
  },
  created() {
    // 獲取 options
    // if(!this.allOptions) {
    //   this.network().getAllOptions()
    // }
    // if(!this.globalOptions) {
    //   this.updateGlobalOptions()
    // }
    this.setErrorData(null)
  },
  methods: {
    ...mapActions('errorfield', ['setErrorData']),
    // ...mapActions('common', ['setAllOptions', 'updateGlobalOptions']),
    // network() {
    //   return {
    //     getAllOptions: async () => {
    //       const { data } = await getAllOptions()
    //       console.log(data)
    //       this.setAllOptions(data)
    //       sessionStorage.setItem('ALL_OPTIONS', JSON.stringify(data))
    //     }
    //   }
    // }
    handleLoading(val){
      this.loading = val
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page-container {
  width: 100%;
  height: 100%;
  .home-container{
    width: 100%;
    height: 100%;
  }
  .in-container {
    flex: 1;
    height: 100%;
  }
  .el-header {
    padding: 0;
    z-index: 10;
  }
  .white{
    background: #FFFFFF;
  }
}
</style>
